import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }                             from '../shared/shared.module';
import { TableModule }                              from '../table/table.module';
import { VendorInvoicesForPaymentComponent }        from '../vendor-invoices/vendor-invoices.for-payment.component';
import { VendorPaymentEmailRemittanceComponent }    from './vendor-payment.email-remittance.component';

@NgModule({
  declarations: [
    VendorInvoicesForPaymentComponent,
    VendorPaymentEmailRemittanceComponent
  ],
  entryComponents: [
    VendorInvoicesForPaymentComponent,
    VendorPaymentEmailRemittanceComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class VendorPaymentsModule {}
